import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { IRACING_AUTH_API_BASE, IRACING_AUTH_LOGIN_URL } from "../utils/iracingAuthApi";
import { MEMBER_CONSENT_CHANGE_EVENT } from "../utils/driverPrivacy";
import "../styles/IracingPrivacyNotice.css";

// Explains why most driver names are hidden, and points members to the
// opt-in. Names are shown only for drivers who have chosen to share them.
const IracingPrivacyNotice = () => {
        const navigate = useNavigate();
        const token = typeof window !== 'undefined' ? localStorage.getItem('token') : null;
        const signedIn = !!token;
        const [consent, setConsent] = useState(null);
        const [refresh, setRefresh] = useState(0);

        useEffect(() => {
                const refreshConsent = () => setRefresh(value => value + 1);
                const events = ['storage', 'focus', 'iracinglink-changed', MEMBER_CONSENT_CHANGE_EVENT];
                events.forEach(event => window.addEventListener(event, refreshConsent));
                return () => events.forEach(event => window.removeEventListener(event, refreshConsent));
        }, []);

        useEffect(() => {
                if (!token) return;
                const controller = new AbortController();
                setConsent(null);
                const loadConsent = async () => {
                        try {
                                const response = await fetch(`${IRACING_AUTH_API_BASE}/api/member-consent`, {
                                        headers: { Authorization: `Bearer ${token}` },
                                        signal: controller.signal,
                                });
                                if (!response.ok) return;
                                const data = await response.json();
                                if (!controller.signal.aborted) {
                                        setConsent({ token, shared: data.consent });
                                }
                        } catch (err) {
                                if (err.name !== 'AbortError') console.error('member-consent notice load error:', err);
                        }
                };
                loadConsent();
                return () => controller.abort();
        }, [token, refresh]);

        // Only prompt signed-in members after confirming they have not opted
        // in. Loading/error states should never imply that their choice failed.
        if (signedIn && (consent?.token !== token || consent.shared !== false)) return null;

        return (
                <div className="iracing-privacy-notice">
                        <span>Driver names are shown only for drivers who have opted in.</span>
                        <button
                                type="button"
                                className="iracing-privacy-signin"
                                onClick={() => {
                                        if (signedIn) navigate("/account");
                                        else window.location.href = IRACING_AUTH_LOGIN_URL;
                                }}
                        >
                                <img src="/iRacing-Icon-BW-White.png" alt="" className="iracing-privacy-logo" />
                                {signedIn ? "Show my name" : "Sign in with iRacing to show yours"}
                        </button>
                </div>
        );
};

export default IracingPrivacyNotice;
